
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/ncd/general",
      function () {
        return require("private-next-pages/help/ncd/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/ncd/general"])
      });
    }
  